module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"form":{"name":"Name","phone":"Phone","message":"Message","sending":"Sending...","send":"Send"}},"ru":{"form":{"name":"Имя","phone":"Телефон","message":"Сообщение","sending":"Отправляю...","send":"Отправить"}}}')
  delete Component.options._Ctor
}
